import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const OfferPartnerFormSummary = ({ partner, t }) => (
  <Grid container>
    <Grid item xs={6} sm={6} md={6}>
      <strong>{t('OfferEdit.Client.PartnerType')}:</strong>{' '}
      {partner.partnerType && <span id={'offerPartnerFormCard_summary_partnerType'}>{partner.partnerType.partnerTypeName}</span>}
    </Grid>
    <Grid item xs={6} sm={6} md={6}>
      <strong>{t('OfferEdit.Client.Name')}:</strong>{' '}
      <span id={'offerPartnerFormCard_summary_partnerName'}>{partner.generalData.partnerName || ''}</span>
    </Grid>
  </Grid>
);

OfferPartnerFormSummary.propTypes = {
  partner: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(OfferPartnerFormSummary);
